import React, { useState } from 'react';
import SEO from '../components/SEO';
import seoData from '../config/seoData';
import { Phone, MessageCircle, Mail, MapPin, Clock, CheckCircle, Wrench, Instagram, ArrowRight, ChevronDown, Shield, Award, FileCheck, Gauge, Zap, Package } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { useNavigate, Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import { useToast } from '../hooks/use-toast';

const ReformaTennantM20 = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    nome: '',
    empresa: '',
    telefone: '',
    email: '',
    cidade: '',
    mensagem: ''
  });

  const whatsappNumber = "5531971823249";

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Olá! Gostaria de solicitar um orçamento para Reforma Tennant M20.");
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const handleFormSubmit = (type) => {
    // Validação
    if (!formData.nome || !formData.telefone) {
      toast({
        title: "Campos obrigatórios",
        description: "Por favor, preencha Nome e Telefone.",
        variant: "destructive"
      });
      return;
    }

    const message = `
*SOLICITAÇÃO REFORMA TENNANT M20*

*Nome:* ${formData.nome}
${formData.empresa ? `*Empresa:* ${formData.empresa}` : ''}
*Telefone:* ${formData.telefone}
${formData.email ? `*E-mail:* ${formData.email}` : ''}
${formData.cidade ? `*Cidade/UF:* ${formData.cidade}` : ''}
${formData.mensagem ? `*Mensagem:* ${formData.mensagem}` : ''}
    `.trim();

    if (type === 'whatsapp') {
      window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } else {
      const emailBody = encodeURIComponent(message.replace(/\*/g, ''));
      window.location.href = `mailto:Wellington@wellttec.com?subject=Solicitação Reforma Tennant M20&body=${emailBody}`;
    }
  };

  const problemas = [
  "Consumo excessivo de óleo",
  "Vazamentos hidráulicos",
  "Baixa produtividade",
  "Falhas no sistema de escovação",
  "Falhas eletrônicas",
  "Alto custo de manutenção",
  "Desgaste estrutural",
  "Máquina parada frequentemente"];


  const etapas = [
  "Diagnóstico técnico completo",
  "Desmontagem integral",
  "Recuperação estrutural",
  "Revisão do motor",
  "Revisão hidráulica",
  "Revisão elétrica",
  "Substituição de componentes críticos",
  "Pintura técnica industrial",
  "Testes operacionais completos",
  "Entrega pronta para operação"];


  const galeria = [
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/mdeqkdol_8FF27927-9037-4AD6-A883-DC238F511918.jpg", caption: "Troca de  \xF3leo" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/trd1bijz_FBB680AB-B33B-41DE-932B-DCC7E37B377F.jpg", caption: "Diagnóstico técnico — leitura horímetro" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/sixj43wc_IMG_2407.jpg", caption: "Revisão do motor Mitsubishi" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/28l0yuce_IMG_20250728_164112.jpg", caption: "Desmontagem do chicote elétrico" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/ok4cza5b_IMG_20250509_154904.jpg", caption: "Reforma de estruturas enferrujadas e deterioradas" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/22gg7h6w_IMG_20250612_155517.jpg", caption: "Reforma da caçamba de detritos" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/otdezogh_IMG_2134.jpg", caption: "Deck de escovas após pintura técnica" },
  { url: "https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/n7nqav11_IMG_20250804_110454.jpg", caption: "Motor remontado pronto para teste" }];


  const diferenciais = [
  { metric: "Tennant", title: "Especialista em Tennant M20", desc: "Esta página é dedicada ao RECON Tennant M20. A WellTec atende também outras marcas e modelos." },
  { metric: "+7", title: "Anos de experiência", desc: "7 anos atuando com reforma e manutenção de varredeiras e lavadoras industriais." },
  { metric: "100%", title: "Peças originais e compatíveis", desc: "Garantia de qualidade em todos os componentes" },
  { metric: "BR", title: "Atendimento em todo Brasil", desc: "Não importa onde você está, atendemos" },
  { metric: "PRO", title: "Equipe técnica experiente", desc: "Profissionais qualificados e certificados" },
  { metric: "DOC", title: "Reformas documentadas", desc: "Registro completo de todas as etapas" },
  { metric: "QA", title: "Testes operacionais", desc: "Validação completa antes da entrega" },
  { metric: "365", title: "Suporte pós-serviço", desc: "Acompanhamento contínuo após a reforma" }];


  const beneficios = [
  { icon: <Gauge className="w-8 h-8" />, title: "Redução de investimento", desc: "Economize até 60% comparado à compra de uma máquina nova" },
  { icon: <Zap className="w-8 h-8" />, title: "Retorno mais rápido", desc: "ROI em tempo reduzido com equipamento renovado" },
  { icon: <Clock className="w-8 h-8" />, title: "Menor tempo de parada", desc: "Máquina operacional em até 30 dias" },
  { icon: <Award className="w-8 h-8" />, title: "Maior vida útil", desc: "Dobra o ciclo de vida do equipamento" },
  { icon: <Shield className="w-8 h-8" />, title: "Preservação do patrimônio", desc: "Valorização do ativo da empresa" }];


  return (
    <div className="min-h-screen
      <SEO 
        title={seoData['/reforma-tennant-m20'].title}
        description={seoData['/reforma-tennant-m20'].description}
        canonical={seoData['/reforma-tennant-m20'].canonical}
      /> bg-white">
      {/* Meta Tags (would be in Helmet or similar) */}
      
      {/* Fixed WhatsApp Button */}
      <div className="fixed bottom-6 left-6 z-50">
        <Button
          onClick={handleWhatsAppClick}
          data-testid="whatsapp-float-button"
          className="bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full w-16 h-16 shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110">

          <MessageCircle className="w-8 h-8" />
        </Button>
      </div>

      {/* Header */}
      <header className="bg-slate-900 text-white py-4 px-6 sticky top-0 z-40 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9nveujmi_file_00000000e2f071f5a40c0fc04e1c9bed.png"
              alt="WellTec Logo"
              className="h-16 w-auto" />

          </div>
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="hover:text-green-400 transition-colors">Início</Link>
            <Link to="/servicos" className="hover:text-green-400 transition-colors">Serviços</Link>
            <Link to="/limpeza-pos-obra" className="hover:text-green-400 transition-colors">Limpeza Pós-Obra</Link>
            <Link to="/locacao-lavadora-piso" className="hover:text-green-400 transition-colors">Locação</Link>
            <Link to="/blog" className="hover:text-green-400 transition-colors">Blog</Link>
            <a
              href="https://www.instagram.com/welltecbrasil/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-green-400 transition-colors">

              <Instagram className="w-5 h-5" />
            </a>
            <Button onClick={handleWhatsAppClick} className="bg-green-600 hover:bg-green-700">
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20 md:py-32 overflow-hidden">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: 'url("https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/ok4cza5b_IMG_20250509_154904.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}>
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/95 to-slate-900/80"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-green-400 font-semibold mb-4 tracking-wider uppercase text-sm">REFORMA TENNANT M20 · PADRÃO RECON</p>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                REFORMA COMPLETA <span className="text-green-400">TENNANT M20</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Recupere o desempenho da sua máquina industrial. A WellTec realiza a reforma completa de lavadoras e varredeiras Tennant M20 — uma manutenção pesada no padrão da remanufatura RECON da fabricante — devolvendo desempenho, confiabilidade e vida útil ao equipamento.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <Button
                  onClick={handleWhatsAppClick}
                  data-testid="hero-quote-button"
                  size="lg"
                  className="bg-green-600 hover:bg-green-700 text-white text-lg px-8 py-6">

                  Solicitar Orçamento
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
                <Button
                  onClick={handleWhatsAppClick}
                  data-testid="hero-whatsapp-button"
                  size="lg"
                  variant="outline"
                  className="border-green-400 text-green-400 hover:bg-green-400 hover:text-white text-lg px-8 py-6">

                  <MessageCircle className="w-5 h-5 mr-2" />
                  Falar no WhatsApp
                </Button>
              </div>

              {/* Trust Strip */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                <div>
                  <p className="text-2xl font-bold text-green-400">+7 Anos</p>
                  <p className="text-sm text-gray-400">Experiência</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-green-400">Multi</p>
                  <p className="text-sm text-gray-400">Marcas/modelos</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-green-400">BR</p>
                  <p className="text-sm text-gray-400">Todo Brasil</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-green-400">QA</p>
                  <p className="text-sm text-gray-400">Testes completos</p>
                </div>
              </div>
            </div>

            {/* Card Escopo */}
            <Card className="bg-slate-800 border-slate-700">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Escopo do Serviço</h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-400 mr-3 flex-shrink-0 mt-0.5" />
                    <span>Diagnostico tecnico </span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-400 mr-3 flex-shrink-0 mt-0.5" />
                    <span>Desmontagem geral</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-400 mr-3 flex-shrink-0 mt-0.5" />
                    <span>Reforma e substituição de peças </span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-400 mr-3 flex-shrink-0 mt-0.5" />
                    <span>Montagem </span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-400 mr-3 flex-shrink-0 mt-0.5" />
                    <span>Teste de todas as funcionalidades</span>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Problemas Comuns */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Sua Tennant M20 apresenta algum destes problemas?
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {problemas.map((problema, index) =>
            <Card key={index} className="bg-white border-slate-200 hover:border-green-400 transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-green-600 mb-2">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <p className="text-slate-700 font-medium">{problema}</p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* O Que a WellTec Faz */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 text-center">
              Reforma Completa Tennant M20 no padrão RECON
            </h2>
            <p className="text-lg text-gray-700 mb-12 text-center max-w-4xl mx-auto">
              Inspirados no conceito de remanufatura RECON — termo utilizado pela fabricante Tennant para a reforma completa do equipamento — a WellTec entrega uma reforma profunda da sua máquina, com inspeção detalhada e recuperação integral dos sistemas mecânicos, hidráulicos, elétricos e estruturais, seguindo um protocolo técnico documentado etapa por etapa.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-12">
              {etapas.map((etapa, index) =>
              <div key={index} className="flex items-start space-x-4 bg-gray-50 p-6 rounded-lg">
                  <div className="bg-green-600 text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                    {index + 1}
                  </div>
                  <p className="text-slate-900 font-medium">{etapa}</p>
                </div>
              )}
            </div>

            <div className="text-center">
              <img
                src="https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/sixj43wc_IMG_2407.jpg"
                alt="Revisão Motor Mitsubishi"
                className="w-full max-w-3xl mx-auto rounded-lg shadow-xl mb-4" />

              <p className="text-gray-600 italic">Revisão Motor — Diagnóstico, abertura e remontagem do conjunto motor Mitsubishi.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Galeria Técnica */}
      <section className="py-20 bg-slate-900">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
            Galeria Técnica
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {galeria.map((foto, index) =>
            <div key={index} className="group relative overflow-hidden rounded-lg aspect-square">
                <img
                src={foto.url}
                alt={foto.caption}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <p className="text-white text-sm p-4 font-medium">{foto.caption}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-12 text-center">
            Por que escolher a WellTec?
          </h2>
          <div className="grid md:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {diferenciais.map((diff, index) =>
            <Card key={index} className="bg-gray-50 border-slate-200 hover:border-green-400 transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="text-4xl font-bold text-green-600 mb-3">{diff.metric}</div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{diff.title}</h3>
                  <p className="text-sm text-gray-600">{diff.desc}</p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* Antes e Depois */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-12 text-center">
            Transformamos equipamentos condenados em máquinas produtivas
          </h2>
          <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            <Card className="bg-white border-red-200 border-2">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-red-600 mb-6 text-center">ANTES</h3>
                <img
                  src="https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/mdeqkdol_8FF27927-9037-4AD6-A883-DC238F511918.jpg"
                  alt="Antes da reforma"
                  className="w-full rounded-lg mb-6" />

                <ul className="space-y-3">
                  <li className="flex items-center text-gray-700">
                    <span className="text-red-500 mr-2">✗</span> Vazamentos
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="text-red-500 mr-2">✗</span> Desgaste estrutural
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="text-red-500 mr-2">✗</span> Falhas recorrentes
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="text-red-500 mr-2">✗</span> Baixa produtividade
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="text-red-500 mr-2">✗</span> Paradas constantes
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card className="bg-white border-green-400 border-2">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-green-600 mb-6 text-center">DEPOIS</h3>
                <img
                  src="https://customer-assets.emergentagent.com/job_tennant-m20-reforma/artifacts/n7nqav11_IMG_20250804_110454.jpg"
                  alt="Depois da reforma"
                  className="w-full rounded-lg mb-6" />

                <ul className="space-y-3">
                  <li className="flex items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2" /> Sistema revisado
                  </li>
                  <li className="flex items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2" /> Maior confiabilidade
                  </li>
                  <li className="flex items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2" /> Melhor desempenho
                  </li>
                  <li className="flex items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2" /> Redução de custos
                  </li>
                  <li className="flex items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2" /> Vida útil ampliada
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Benefícios Financeiros */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 text-center">
            Reformar ou comprar outra máquina?
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
            <div className="text-center">
              <div className="text-5xl font-bold text-green-600 mb-2">60%+</div>
              <p className="text-lg text-gray-700">Economia</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-green-600 mb-2">2x</div>
              <p className="text-lg text-gray-700">Vida útil</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-green-600 mb-2">30d</div>
              <p className="text-lg text-gray-700">Prazo típico</p>
            </div>
          </div>

          <div className="grid md:grid-cols-5 gap-6 max-w-6xl mx-auto">
            {beneficios.map((beneficio, index) =>
            <Card key={index} className="bg-gray-50 border-slate-200 hover:border-green-400 transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="text-green-600 mb-4 flex justify-center">
                    {beneficio.icon}
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">{beneficio.title}</h3>
                  <p className="text-sm text-gray-600">{beneficio.desc}</p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-12 text-center">
            Perguntas Frequentes
          </h2>
          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              <AccordionItem value="item-1" className="bg-white border border-slate-200 rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-slate-900">
                  O que é RECON e a WellTec faz esse tipo de reforma?
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  RECON é o termo utilizado pela fabricante Tennant para se referir à reforma completa do equipamento. A WellTec não é vinculada à Tennant, mas executa uma reforma profunda da Tennant M20 nesse mesmo padrão técnico — recuperação integral dos sistemas mecânicos, hidráulicos, elétricos e estruturais, com protocolo documentado etapa por etapa.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2" className="bg-white border border-slate-200 rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-slate-900">
                  Quanto tempo leva uma reforma completa (RECON) da Tennant M20?
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  O prazo típico varia de 30 a 45 dias, dependendo do estado do equipamento e da disponibilidade de peças. Após o diagnóstico inicial, fornecemos um cronograma detalhado.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3" className="bg-white border border-slate-200 rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-slate-900">
                  A WellTec atende fora de Minas Gerais?
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  Sim, atendemos todo o Brasil. Temos experiência com logística de equipamentos de grande porte e podemos coordenar o transporte ou realizar o serviço in loco, dependendo do caso.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-4" className="bg-white border border-slate-200 rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-slate-900">
                  Vocês fornecem peças para Tennant M20?
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  Sim, fornecemos peças originais e equivalentes homologadas para Tennant M20, incluindo componentes do motor Mitsubishi e GM, sistema hidráulico, elétrico e estrutural.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-5" className="bg-white border border-slate-200 rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-slate-900">
                  A máquina recebe testes após a reforma?
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  Sim, todos os equipamentos passam por testes operacionais completos antes da entrega, incluindo verificação de todos os sistemas mecânicos, hidráulicos, elétricos e de segurança.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-6" className="bg-white border border-slate-200 rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-slate-900">
                  Vocês trabalham com Tennant M20 Diesel e GLP?
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  Sim, atendemos ambas as motorizações (Diesel e GLP), incluindo os motores Mitsubishi e GM utilizados na Tennant M20.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>


      {/* Formulário de Contato */}
      <ContactForm />

      {/* Footer */}
      <footer className="bg-slate-950 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="mb-4">
                <img
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9nveujmi_file_00000000e2f071f5a40c0fc04e1c9bed.png"
                  alt="WellTec Logo"
                  className="h-20 w-auto" />

              </div>
              <p className="text-gray-400 mb-4 text-sm">
                Especialistas em reforma e manutenção de lavadoras e varredeiras industriais.
              </p>
              <a
                href="https://www.instagram.com/welltecbrasil/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-gray-400 hover:text-white transition-colors">

                <Instagram className="w-5 h-5" />
                <span>@welltecbrasil</span>
              </a>
            </div>
            <div>
              <h5 className="text-lg font-bold mb-4">Navegação</h5>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Início</Link></li>
                <li><Link to="/servicos" className="text-gray-400 hover:text-white transition-colors">Serviços</Link></li>
                <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors">Blog</Link></li>
                <li></li>
              </ul>
            </div>
            <div>
              <h5 className="text-lg font-bold mb-4">Contato</h5>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>(31) 97182-3249</li>
                <li>Wellington@wellttec.com</li>
                <li>Mário Campos, MG</li>
                <li>Atendimento: Todo o Brasil</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-800 pt-8">
            <p className="text-center text-gray-400 text-sm mb-2">
              &copy; 2025 WellTec - Locações e Serviços Técnicos. Todos os direitos reservados.
            </p>
            <p className="text-center text-gray-500 text-xs">
              Tennant® é marca registrada de seus respectivos proprietários. A WellTec é uma empresa independente de assistência técnica e reforma.
            </p>
          </div>
        </div>
      </footer>
    </div>);

};

export default ReformaTennantM20;